import { Navigate, useLocation, useSearchParams } from "react-router-dom";

type RedirectState = {
  ownerId?: string;
};

export default function RedirectNewPet() {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const ownerIdFromQuery = searchParams.get("owner_id")?.trim() ?? "";
  const stateOwnerId =
    ((location.state as RedirectState | null) ?? null)?.ownerId?.trim() ?? "";

  const ownerId = ownerIdFromQuery || stateOwnerId;
  const target = ownerId
    ? `/patients/new?owner_id=${encodeURIComponent(ownerId)}`
    : "/patients/new";

  return <Navigate to={target} replace />;
}

